<div class="bg-white shadow rounded-lg p-6 mb-8 text-center mt-4">
    <h1 class="text-2xl font-bold mb-2">Liste de prédictions :</h1>
    <p-table [value]="sortedPredictions()" [paginator]="true" [rows]="10" class="mt-4">
        <ng-template pTemplate="header">
            <tr>
                <th>Équipe Domicile</th>
                <th>Équipe Extérieure</th>
                <th>Compétition</th>
                <th>Sport</th>

                <th>Confiance Domicile</th>
                <th>Confiance Extérieure</th>
                <th>Date de l'évenement</th>
                <th>Evénement</th>
                <th>Date de création</th>
                <th>Actions</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-prediction>
            <tr>
                <td>{{ prediction.team_home }}</td>
                <td>{{ prediction.team_away }}</td>
                <td>{{ prediction.competition }}</td>
                <td>{{ prediction.sport }}</td>
                <td>{{ prediction.confidence_team_away }}</td>
                <td>{{ prediction.confidence_team_home }}</td>
                <td>{{ prediction.event_date | date }}</td>
                <td>{{ prediction.event_name }}</td>
                <td>{{ prediction.created_at | date }}</td>

                <td class="">
                    <button pButton icon="pi pi-pencil" class="p-button-rounded p-button-text"
                        (click)="editPrediction(prediction)"></button>
                    <button pButton icon="pi pi-trash" class="p-button-rounded p-button-text"
                        (click)="deletePrediction(prediction.id, $event)"></button>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>

<p-confirmdialog />
<p-toast  />